import { Component, ComponentFactoryResolver, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import * as Papi from '@app/papi';
import { Helpers } from '../../helpers';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';

@Component({
	templateUrl: './verify-user.component.html',
	encapsulation: ViewEncapsulation.None,
	standalone: false
})

export class VerifyUserComponent implements OnInit {
	@ViewChild('verifySuccess', { static: true }) private verifySuccess: SwalComponent;
	@ViewChild('verifyError', { static: true }) private verifyError: SwalComponent;

	model: any = {};
	loading = true;
	token: string = '';

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private papi: Papi.Service) {
	}

	ngOnInit(): void {
		this.token = this.route.snapshot.paramMap.get('token');
		Helpers.setLoading(true);
		this.verifyUser();
	}

	verifyUser() {
		this.loading = true;
		this.papi.fauxInit();
		this.papi.db.verifyUser('THIS NEEDS TO BE REFACTORED TO TAKE USER EMAIL ADDRESS', this.token, 'body', true).subscribe((data) => {
			this.verifySuccess.fire().then(() => {
				this.loading = false;
			});
		}, (error) => {
			this.verifyError.text = error.message || error.error.message || error.error.error.message || 'There was an error verifying your account.';
			this.verifyError.fire().then(() => {
				this.loading = false;
			});
			this.router.navigate(['login']);
		});
	}
}